import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'

import * as styles from './SendEmailForm.module.scss'
import useFormInput from '../../../helpers/hooks/useFormInput'
import useFormSubmit from '../../../helpers/hooks/useFormSubmit'
import ButtonWithSpiner from '../../ui/buttons/button-with-spiner/ButtonWithSpiner'
import InputError from '../../ui/error/Error'
import Input from '../../ui/input/Input'
import Label from '../../ui/label/Label'

function SendEmailForm({
  className,
  buttonContent,
  URL,
  label,
  hideLabel,
  inputId,
  onUserSuccesfullySubmited,
  buttonClass,
  small,
  ...rest
}) {
  const userEmail = useFormInput('')

  const email = userEmail.value

  const {
    loadingState: isLoading,
    submitedState,
    errorState,
    handleSubmit,
  } = useFormSubmit()

  const handleFormSubmit = async event => {
    try {
      event.preventDefault()

      const data = `email=${email}`

      await handleSubmit(URL, data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (submitedState && onUserSuccesfullySubmited) {
      onUserSuccesfullySubmited()
    }
  }, [submitedState])

  return (
    <form
      className={classNames(styles.form, className)}
      onSubmit={handleFormSubmit}
      {...rest}
    >
      <div className={styles.formItem}>
        <Label className={styles.label} htmlFor={inputId} hidden={hideLabel}>
          {label}
        </Label>
        <Input
          id={inputId}
          className={styles.input}
          name="email"
          type="email"
          placeholder="Email address"
          required
          small={small}
          {...userEmail}
        />
        {errorState && !isLoading && (
          <InputError className={styles.errorText}>
            Please try entering your email again.
          </InputError>
        )}
      </div>

      <ButtonWithSpiner
        className={classNames(styles.btn, buttonClass)}
        type="submit"
        small={small}
        {...{ buttonContent, isLoading }}
      />
    </form>
  )
}

SendEmailForm.propTypes = {
  URL: PropTypes.string.isRequired,
  inputId: PropTypes.string.isRequired,
  buttonContent: PropTypes.string,
  className: PropTypes.string,
  buttonClass: PropTypes.string,
  hideLabel: PropTypes.bool,
  small: PropTypes.bool,
  onUserSuccesfullySubmited: PropTypes.func,
}

export default SendEmailForm
